// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/needs-goals-item/needs-goals-item.component.scss
// module id = 139
// module chunks = 0